import { render, staticRenderFns } from "./PricingOptionProperty.vue?vue&type=template&id=2cd4e115&scoped=true&"
import script from "./PricingOptionProperty.vue?vue&type=script&lang=js&"
export * from "./PricingOptionProperty.vue?vue&type=script&lang=js&"
import style0 from "./PricingOptionProperty.vue?vue&type=style&index=0&id=2cd4e115&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cd4e115",
  null
  
)

export default component.exports